import { render, staticRenderFns } from "./GigJobDetailsCard.htm?vue&type=template&id=6ace3bbc&scoped=true&"
import script from "./GigJobDetailsCard.ts?vue&type=script&lang=js&"
export * from "./GigJobDetailsCard.ts?vue&type=script&lang=js&"
import style0 from "./GigJobDetailsCard.scss?vue&type=style&index=0&id=6ace3bbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ace3bbc",
  null
  
)

export default component.exports